import React from 'react'
import ReactDOM from 'react-dom'
import { string, bool, func, node } from 'prop-types'
import { Text, Heading } from 'rebass'
import DisableBodyScroll from '../DisableBodyScroll'
import IconClose from '../../vectors/IconClose'
import LinkRounded from '../LinkRounded'
import {
  ModalOuter,
  ModalInner,
  Header,
  Summary,
  ModalDimmer,
  ModalAction,
  Close,
  Shadow
} from './components/ModalStyled'

class Portal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.el =
      typeof window !== 'undefined' ? document.createElement('div') : null
  }

  componentDidMount() {
    this.el && document.body.appendChild(this.el)
  }

  componentWillUnmount() {
    this.el && document.body.removeChild(this.el)
  }

  render() {
    return this.el && ReactDOM.createPortal(this.props.children, this.el)
  }
}

class ContentModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.addEventListeners = this.addEventListeners.bind(this)
    this.removeEventListeners = this.removeEventListeners.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleKeyPressed = this.handleKeyPressed.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.isWindowAvailable = typeof window !== 'undefined'
  }

  componentDidMount() {
    this.addEventListeners()
  }

  componentWillUnmount() {
    this.removeEventListeners()
  }

  handleKeyPressed(e) {
    if (!this.props.open) return false
    if (e.keyCode && e.keyCode === 27) {
      this.handleClose()
    }
  }

  handleClickOutside() {
    if (!this.props.open) return false
    if (this.props.onClose) this.props.onClose()
  }

  handleClose(e) {
    if (e) e.preventDefault()
    if (this.props.onClose) this.props.onClose()
  }

  addEventListeners() {
    if (this.isWindowAvailable) {
      window.addEventListener('keydown', this.handleKeyPressed)
    }
  }

  removeEventListeners() {
    if (this.isWindowAvailable) {
      window.removeEventListener('keydown', this.handleKeyPressed)
    }
  }

  render() {
    return (
      <Portal>
        <ModalDimmer
          className={this.props.open ? 'show' : 'hide'}
          onClick={this.handleClickOutside}
        />
        <DisableBodyScroll disableScroll={this.props.open} />
        {this.props.open && (
          <article
            role="dialog"
            aria-labelledby="dialog-heading"
            ref={(e) => {
              this.Modal = e
            }}
          >
            <ModalOuter mx="auto" slim={!!this.props.slim}>
              <ModalInner flexWrap="wrap">
                <Shadow />
                <Header as="header" width={2 / 2} py={23} px={40}>
                  <Heading
                    id="dialog-heading"
                    as="h3"
                    f={[5, 6, 7]}
                    color="white"
                  >
                    {this.props.title}
                  </Heading>
                  {this.props.subtitle && (
                    <Text f={[4, 5, 6]} color="white">
                      {this.props.subtitle}
                    </Text>
                  )}
                  <Close
                    aria-label="close"
                    onClick={this.handleClose}
                    tabIndex="0"
                  >
                    <IconClose />
                  </Close>
                </Header>

                {this.props.children}

                {this.props.action && (
                  <ModalAction>
                    <LinkRounded
                      href={this.props.action.href}
                      onClick={this.handleClose}
                    >
                      {this.props.action.text}
                    </LinkRounded>
                  </ModalAction>
                )}

                {this.props.summary && (
                  <Summary className="summary" px={'12%'} py={60}>
                    <Text>{this.props.summary}</Text>
                  </Summary>
                )}
              </ModalInner>
            </ModalOuter>
          </article>
        )}
      </Portal>
    )
  }
}

ContentModal.defaultProps = {
  open: false,
  slim: false
}
ContentModal.propTypes = {
  title: string,
  subtitle: node,
  summary: string,
  open: bool,
  slim: bool,
  onClose: func
}

export default ContentModal
